import { render, staticRenderFns } from "./ShunyiPerson.vue?vue&type=template&id=5ea5b827&scoped=true"
import script from "./ShunyiPerson.vue?vue&type=script&lang=js"
export * from "./ShunyiPerson.vue?vue&type=script&lang=js"
import style0 from "./ShunyiPerson.vue?vue&type=style&index=0&id=5ea5b827&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea5b827",
  null
  
)

export default component.exports